import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, ITimestampable } from "../../types";

export interface ISkillBlockResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.SKILL_BLOCK;
    title: string;
}

export const isSkillBlockResource = (resource: IHydraResource): resource is ISkillBlockResource => {
    return resource["@type"] === EntityTypes.SKILL_BLOCK;
};
